//特殊开发人员使用的
export default [{
	//首页登录页面,如果是演示系统就会启用特殊配置
	path: '/debugPage',
	name: 'debugPage',
	component: () => import('@/page/debug/debugPage.vue')
}, ]
